module.exports = __webpack_public_path__ + "img/doordescribeLogo.9652b0a8.png";